import { MediumDesktop, Tablet } from 'styles/MediaQueries';
import { NAVY, SKY, WHITE_TEXT } from 'styles/Colors';
import { useNavigate } from 'react-router-dom';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import DesktopSection from 'registration/lead/intro/clickThroughPageSections/DesktopSection';
import MobileSection from 'registration/lead/intro/clickThroughPageSections/MobileSection';
import React, { useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const headerStyle = {
  color: WHITE_TEXT,
  fontWeight: '700',
  fontSize: '1.5rem',
  textAlign: 'center',
  margin: '2rem 0 2rem',

  [MediumDesktop]: {
    fontSize: '2.25rem'
  }
};

const buttonStyle = {
  fontSize: '1rem',
  fontWeight: 'bold',
  margin: '1rem auto 1.5rem auto',
  padding: '1.375rem 4rem',

  [MediumDesktop]: {
    fontSize: '1.25rem',
    minWidth: '23rem'
  }
};

const bottomSectionStyle = {
  background: `linear-gradient(${SKY}, ${NAVY})`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

function ClickThroughBottomSection() {
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery(Tablet);
  const navigate = useNavigate();

  const handleClick = () => {
    setLoading(true);
    navigate('/register/lead_gate');
  };

  return (
    <div css={bottomSectionStyle}>
      <h1 css={headerStyle}>
        What are the Benefits of Applying and Being Approved?
      </h1>
      {isMobile && <MobileSection />}
      {!isMobile && <DesktopSection />}
      <CtaButton
        additionalStyle={buttonStyle}
        onClick={handleClick}
        disabled={loading}
        loading={loading}
      >
        Start Your Loan Application
      </CtaButton>
    </div>
  );
}

export default ClickThroughBottomSection;
